module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_mobile_writing-ab640688e9bec4b9d45b4a5fc4965414.png";